const SpinnerCustom = () => {
    return (
        <div className="loader"></div>
    )
}
export default SpinnerCustom
